module.exports = __webpack_public_path__ + "static/8i-92da6f116d973bd334cf9b3afdb29c4f.woff";